import React, { useState } from "react";
import classes from "./FAQPage.module.css";

const faqData = [
  {
    question: "What is AgricZone about?",
    answer:
      "AgricZone provides a complete range of Agri solutions at your fingertips. There is simple and detailed information on modern farming methods and agriculture practices. As home gardening is picking up, the portal also helps people with different types of gardening tips along with other commercial agriculture practices."
  },
  {
    question: "How can I subscribe to AgricZone?",
    answer:
      "You can subscribe to AgricZone by clicking on the service link: http://xxxxxxxxxxxxxx/"
  },
  {
    question: "Is this compatible for all phones?",
    answer:
      "Yes, all data-enabled feature phone and smartphone users can enjoy the full service."
  },
  {
    question: "What would be the charges to subscribe to AgricZone?",
    answer:
      "AgricZone subscription comes at a charge of xx daily."
  },
  {
    question: "How long can I use this service?",
    answer:
      "Customers can access content at any time during the subscription validity period."
  },
  {
    question:
      "If I am an existing user of AgricZone and wish to unsubscribe, how can I do this?",
    answer:
      "You can unsubscribe by selecting the UNSUB option within the portal."
  }
];

const FaqPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <header className={classes.header}>
          <h1>🌾 Frequently Asked Questions</h1>
          <p>Everything you need to know about AgricZone</p>
        </header>

        <div className={classes.faqContainer}>
          {faqData.map((faq, index) => (
            <div
              key={index}
              className={`${classes.faqItem} ${
                activeIndex === index ? classes.active : ""
              }`}
            >
              <button
                className={classes.question}
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <span className={classes.icon}>
                  {activeIndex === index ? "−" : "+"}
                </span>
              </button>

              <div className={classes.answer}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqPage;